import kiosks from '../resources/kiosks';
import { CLEAR, IS_LOADING, UPDATE_KIOSK } from './kioskContext';

// Fetch kiosk data and update state accordingly
export const fetchKioskData = async (state, dispatch) => {
  const clone = { ...state };
  dispatch({ type: IS_LOADING, payload: true });
  try {
    clone.kiosk = await kiosks.fetchByAuthCredentials();
    clone.connectionOk = true;
    clone.isFetched = true;
    clone.error = undefined;
    clone.isLoading = false;
    dispatch({ type: UPDATE_KIOSK, payload: clone });
  } catch (error) {
    if (error.request) {
      clone.connectionOk = false;
    }
    clone.error = error;
    clone.isLoading = false;
    dispatch({ type: UPDATE_KIOSK, payload: clone });
  }
  return clone;
};

export const clearKioskData = dispatch => {
  dispatch(CLEAR);
};
